import { useEffect } from "react";
import useLogout from "core/custom-hooks/useLogout";
import useSelfService from "core/custom-hooks/useSelfService";
import useInquiryManagement from "core/custom-hooks/useInquiryManagement"
import useStore from "core/custom-hooks/useStore";
import useToastify from "core/custom-hooks/useToastify";
import { openPopup } from "components/Popup/Popup";
import {
    setIsMobileMenuOpen,
    setPopup,
    setMobileAppWrapperData,
} from "core/store/actionCreators";
import * as Utils from "core/common/utils";
import mobileAppEventType from "core/common/types/mobileAppEventType";
import * as TagManager from "core/common/seo/tagManager";

const useSiteStructure = () => {
    const { state, dispatch } = useStore();
    const { T, business, isAdmin, mobileAppWrapperData, cfg } = state;

    const {
        isBiometricLoginEnabled,
        mobileEventEmitter,
        hebrewBiometryType,
    } = mobileAppWrapperData;

    const { handleLogout } = useLogout();
    const {
        toastifySuccess,
        toastifyInfo,
        toastifyWarn,
        toastifyError,
    } = useToastify();

    const isDev = Utils.isDevEnvironment;

    const isBusinessEmpty = business == null || business === 'undefined' || Object.keys(business).length === 0;
    const isActive = (isBusinessEmpty || business.is_active);
    const isRRH = (business?.cust_status_type === 'רר\"ח');

    let siteStructure = [
        {
            systemOnly: true,
            svgIconName: "manage_accounts",
            id: "menu-manage-accounts",
            title: "Membership",
            sub: [
                {
                    title: "Admin New",
                    navigateTo: "/membership/admin-new",
                },
                {
                    title: "Admin Delete",
                    navigateTo: "/membership/admin-delete",
                },
                {
                    title: "Member",
                    navigateTo: "/membership/member",
                },
                {
                    title: "Rules",
                    navigateTo: "/membership/rules",
                },
                {
                    title: "Rule Groups",
                    navigateTo: "/membership/rule-groups",
                },
            ],
            isBusissnessNotActive: !isActive
        },

        {
            svgIconName: "edit",
            title: "דוגמאות",
            isDevOnly: true,
            sub: [
                {
                    title: "Validations",
                    navigateTo: "/formikexample",
                },
                {
                    title: "Popup",
                    action: () => {
                        openPopup(
                            dispatch,
                            "Main title",
                            "Sub title",
                            "main button text",
                            () => {
                                alert("ok");
                            }
                        );
                    },
                },
                {
                    title: "useToastify - Success",
                    action: () => {
                        toastifySuccess("הפעולה הצליחה");
                    },
                },
                {
                    title: "useToastify - Info",
                    action: () => {
                        toastifyInfo("מידע מועיל");
                    },
                },
                {
                    title: "useToastify - Warn",
                    action: () => {
                        toastifyWarn("אזהרה");
                    },
                    sub: [
                        {
                            id: "menu-general-details",
                            title: "פרטים כלליים",
                            navigateTo: "/business-overview",
                            dataElemntKey: "business",
                            tagManagerDetails: {
                                category: `side menu-${business?.business_id}`,
                                action: "business details link",
                            },
                        },
                        {
                            id: "menu-your-contacts",
                            title: "אנשי הקשר שלך",
                            navigateTo: "/contactList",
                            dataElemntKey: "contacts",
                            tagManagerDetails: {
                                category: `side menu-${business?.business_id}`,
                                action: "business contacts link",
                            },
                        },
                    ],
                },
                {
                    title: "useToastify - Error",
                    action: () => {
                        toastifyError("שגיאה");
                    },
                },
            ],
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "home1",
            id: "menu-home",
            title: "ראשי",
            navigateTo: "/home",
            dataElemntKey: "home",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "home page link",
            },
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "zap-coupons",
            id: "menu-zap-coupons",
            title: "ניהול שוברים - zap",
            navigateTo: "/zap-coupons",
            condition: business?.is_zap_coupons || false,
            dataElemntKey: "zap-coupons",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "zap-coupons page link",
            },
            isBusissnessNotActive: !isActive
        },

        {
            svgIconName: "delivery2",
            id: "menu-Delivery",
            title: T("DILIVERY_MANAGMENT"),
            hideMenuInMobile: true,
            autoOpen: true,
            dataElemntKey: "Delivery",
            ...useSelfService(),
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "click on Delivery button",
            },
            sub: [
                {
                    id: "order-confirmation",
                    svgIconName: "clock",
                    condition: business?.sites?.filter(a => a.id === 3 && (a.primaryTags[0]?.IsMishlohimPayme || a.primaryTags[0]?.IsAcceptOnlineOrders)).length > 0,
                    title: "אישור הזמנות",
                    navigateTo: "/order-confirmation",
                    dataElemntKey: "order-confirmation",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "orders link",
                    },
                },
                {
                    id: "menu-menu",
                    title: "תפריט משלוחים",
                    navigateTo: "/menu",
                    dataElemntKey: "menu",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "menu link",
                    },
                },
                {
                    id: "delivery-areas",
                    title: "אזורי משלוח",
                    navigateTo: "/delivery-areas",
                    dataElemntKey: "DeliveryAreas",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "DeliveryAreas link",
                    },
                },
                {
                    id: "reports",
                    title: "דוחות",
                    navigateTo: "/reports",
                    dataElemntKey: "reports",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "reports link",
                    },
                },
                {
                    id: "coupons",
                    title: "ניהול קופונים",
                    navigateTo: "/coupons",
                    dataElemntKey: "coupons",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "coupons link",
                    },
                },
                {
                    id: "menu-open-hours",
                    title: "שעות פעילות",
                    navigateTo: "/opening-hours",
                    dataElemntKey: "open-hours",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "menu > opening hours link",
                    },
                },
                {
                    id: "settings",
                    title: "הגדרות",
                    disabled: isRRH ? true : false,
                    navigateTo: "/settings",
                    dataElemntKey: "settings",
                    tagManagerDetails: {
                        category: `side menu-${business?.business_id}`,
                        action: "settings link",
                    },

                }
            ],
            isBusissnessNotActive: !isActive
        },

        {
            svgIconName: "edit",
            id: "menu-gallery",
            title: "תמונות",
            disabled: isRRH ? true : false,
            navigateTo: "/galleries",
            dataElemntKey: "pictures",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "images link",
            },
            isBusissnessNotActive: !isActive
        },
     /*   {
            svgIconName: "stat",
            id: "menu-stat",
            title: "ביצועים וסטטיסטיקות",
            navigateTo: "/statistics",
            dataElemntKey: "stat",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "Performance and statistics link",
            },
            isBusissnessNotActive: !isActive
        },*/
        {
            svgIconName: "homepage-gray-calls",
            id: "menu-calls",
            title: "ניהול שיחות",
            navigateTo: "/calls",
            dataElemntKey: "calls",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "click on calls button",
            },
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "review",
            id: "menu-reviews",
            title: "חוות דעת",
            navigateTo: "/reviews",
            tagManagerDetails: {
                category: `home page-${business?.business_id}`,
                action: "click on reviews button",
            },
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "price-list",
            id: "price-list",
            title: "מחירונים",
            navigateTo: "/price-list",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "price-list link",
            },
            dataElemntKey: "price-list",
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "calls-management",
            id: "menu-inquiry-management",
            title: "כניסה למערכת PPA",
            ...useInquiryManagement(),
            dataElemntKey: "inquiry-management",
            navigateTo: "/ofir-site",
            noNavigate: true,
            isBusissnessNotActive: !isActive
        },

        {
            svgIconName: "business",
            id: "business-menu-business-details",
            title: "האזור שלי",
            navigateTo: "/business-overview",
            dataElemntKey: "business",
            hideMenuInMobile: true,
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "click on business button",
            },
            sub: [{
                svgIconName: "business",
                id: "menu-business-details",
                title: "פרטי עסק",
                navigateTo: "/business-overview",
                dataElemntKey: "business",
                tagManagerDetails: {
                    category: `side menu-${business?.business_id}`,
                    action: "business details link",
                },
            },
            {
                svgIconName: "business",
                title: "זאפ X",
                navigateTo: "/zapx-overview",
                dataElemntKey: "business",
                tagManagerDetails: {
                    category: `side menu-${business?.business_id}`,
                    action: "zapx link",
                },

            },
            {
                svgIconName: "clock",
                title: "שעות פעילות",
                navigateTo: "/opening-hours",
                dataElemntKey: "open-hours",
                tagManagerDetails: {
                    category: `side menu-${business?.business_id}`,
                    action: "opening hours link",
                },

            },
            {
                svgIconName: "ad",
                id: "menu-ads",
                title: "חבילות הפרסום שלי",
                navigateTo: "/ads",
                dataElemntKey: "ad",
                tagManagerDetails: {
                    category: `side menu-${business?.business_id}`,
                    action: "My advertising packages link",
                },

            },
            {
                svgIconName: "recipts",
                id: "menu-invoices",
                title: "חשבוניות",
                navigateTo: "/invoices",
                dataElemntKey: "recipts",
                tagManagerDetails: {
                    category: `side menu-${business?.business_id}`,
                    action: "invoices link",
                },

            },
            ],
            isBusissnessNotActive: !isActive

        },
        {
            svgIconName: "contact",
            id: "menu-contact",
            title: "דברו איתנו",
            navigateTo: "/contact",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "talk to us dropdown",
            },
            dataElemntKey: "contact",
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "edit",
            title: "בקשות שינוי",
            navigateTo: "/change-requests",
            dataElemntKey: "change-requests",
            condition: isAdmin,
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "change requests link",
            },
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "history-actions",
            id: "menu-operation-history",
            title: "היסטוריית פעולות",
            navigateTo: "/operation-history",
            tagManagerDetails: {
                category: `side menu-${business?.business_id}`,
                action: "historical changes",
            },
            condition: isAdmin,
            isBusissnessNotActive: !isActive
        },
        {
            svgIconName: "finger-print-disabling",
            id: "menu-cancel-biometric-login",
            title: "ביטול כניסה חכמה",
            condition: isBiometricLoginEnabled === true,
            action: () => {
                dispatch(setIsMobileMenuOpen(false));
                openPopup(
                    dispatch,
                    "לתשומת לבכם",
                    `האם ברצונכם לבטל את האפשרות להתחבר באמצעות ${hebrewBiometryType}?`,
                    "אישור",
                    () => {
                        mobileEventEmitter(mobileAppEventType.biometricsDisabling, {});
                        dispatch(setPopup({ isOpen: false }));
                        dispatch(
                            setMobileAppWrapperData({ isBiometricLoginEnabled: false })
                        );
                    },
                    null,
                    "ביטול"
                );
            },
        },
        {
            svgIconName: "log-out",
            id: "menu-log-out",
            title: "התנתק",
            action: () => {
                dispatch(setIsMobileMenuOpen(false));
                openPopup(
                    dispatch,
                    "התנתקות",
                    "בטוחים שאתם רוצים לעזוב?",
                    "כן, נתקו אותי",
                    () => {
                        handleLogout();
                        TagManager.sendGoogleEvent({ action: "log out" });
                    },
                    null,
                    "לא, אני רוצה להישאר"
                );
            },
        },
    ];


    const getSiteStructure = () => {
        const x = siteStructure
            .filter((x) => !x.isDevOnly || isDev)
            .filter((x) => x.condition !== false)
            .filter((x) => {
                return (x.systemOnly && isAdmin && cfg.isSystemAdmin) || !x.systemOnly;
            })
            .map((x) => {
                if (x.sub?.length) {

                    const filteredSub = x.sub
                        .map(a => {
                            a.condition = a.condition === undefined || a.condition !== false ? true : false;
                            //console.log({id: a.id, b: a.condition});
                            return a;
                        })
                        .filter((s) => s.condition)

                    if (filteredSub.length) {
                        x.sub = filteredSub;
                    }
                    else {
                        x.sub = null
                    }
                }
                return x;
            })
            ;

        return x;
    };


    const getPageNavigation = (childPath) => {
        for (let element of getSiteStructure()) {
            const { sub } = element;
            const getPathToCompare = (path) =>
                typeof path === "string" && path.trim().toLowerCase();

            if (
                !element.hideMenuInMobile &&
                Array.isArray(sub) &&
                sub.some(
                    (x) =>
                        x.navigateTo &&
                        getPathToCompare(x.navigateTo) === getPathToCompare(childPath)
                )
            ) {
                return sub;
            }
        }
    };

    const isEqualSub = (sub1, sub2) => {
        if (
            !Array.isArray(sub1) ||
            !Array.isArray(sub2) ||
            sub1.length !== sub2.length ||
            sub1.length === 0
        ) {
            return false;
        }

        for (let i = 0; i < sub1.length; i++) {
            const isObject = (obj) => typeof obj === "object";
            const getObjectKeyLength = (obj) => Object.keys(obj).length;

            if (
                !isObject(sub1[i]) ||
                !isObject(sub2[i]) ||
                getObjectKeyLength(sub1[i]) !== getObjectKeyLength(sub2[i])
            ) {
                return false;
            }

            const isAcceptableType = (someVar) =>
                ["string", "boolean", "number"].includes(typeof someVar);
            Object.keys(sub1[i]).forEach((key) => {
                if (isAcceptableType(sub1[i][key]) || isAcceptableType(sub2[i][key])) {
                    if (sub1[i][key] !== sub2[i][key]) {
                        return false;
                    }
                }
            });
        }

        return true;
    };

    return { getSiteStructure, getPageNavigation, isEqualSub };
};

export default useSiteStructure;
